/**
 * The product's name, everywhere it is written.
 *
 * `Opncue`, with no exceptions in prose. Lowercase `opncue` belongs to the
 * LOGO and nothing else — it is a piece of artwork, not a spelling, and the
 * wordmark files are where it lives.
 *
 * This replaced a split rule (2026-08-19): the app used to write itself
 * lowercase inside its own sentences and capitalised only where the name stood
 * alone as a label. That is no longer the convention. The old rule is recorded
 * here because it was deliberate and documented, so anyone finding a lowercase
 * string in an old branch knows it was a decision that was reversed rather than
 * a typo to preserve.
 *
 * Kept in one place because it had been written out by hand in three, and one
 * of them had it as "opnCue" — a casing that belongs to neither convention.
 * That one was the browser-tab fallback, so the wrong spelling was the one
 * people actually saw.
 */
export const BRAND_NAME = "Opncue";

/** The full document title: the name, then what the product is for. */
export const WEB_TITLE = `${BRAND_NAME} - Real conversations start nearby`;
